import fetch from './fetch'

export default {
  getSharePersonRecords (payload) {
    let request = fetch({
      url: `/shareperson`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  sharePerson (payload) {
    let request = fetch({
      url: `/share/person`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  unsharePerson (payload) {
    let request = fetch({
      url: `/unshare/person`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getShareAdvocateRecords (payload) {
    let request = fetch({
      url: `/shareadvocate`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  shareAdvocate (payload) {
    let request = fetch({
      url: `/share/advocate`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  unshareAdvocate (payload) {
    let request = fetch({
      url: `/unshare/advocate`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getShareNoteRecords (payload) {
    let request = fetch({
      url: `/sharenote`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  shareNote (payload) {
    let request = fetch({
      url: `/share/note`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  unshareNote (payload) {
    let request = fetch({
      url: `/unshare/note`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getShareAssessmentRecords (payload) {
    let request = fetch({
      url: `/shareassessment`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  shareAssessment (payload) {
    let request = fetch({
      url: `/share/assessment`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  unshareAssessment (payload) {
    let request = fetch({
      url: `/unshare/assessment`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getShareCseitRecords (payload) {
    let request = fetch({
      url: `/sharecseit`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  shareCseit (payload) {
    let request = fetch({
      url: `/share/cseit`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  unshareCseit (payload) {
    let request = fetch({
      url: `/unshare/cseit`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getShareLaborScreeningRecords (payload) {
    const request = fetch({
      url: `/sharelaborscreening`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  shareLaborScreening (payload) {
    const request = fetch({
      url: `/share/laborscreening`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  unshareLaborScreening (payload) {
    const request = fetch({
      url: `/unshare/laborscreening`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  getShareTraffickingScreeningRecords (payload) {
    const request = fetch({
      url: `/sharetraffickingscreening`,
      method: 'get',
      data: {},
      payload: payload
    })
    return request.call()
  },
  shareTraffickingScreening (payload) {
    const request = fetch({
      url: `/share/traffickingscreening`,
      method: 'post',
      data: payload
    })
    return request.call()
  },
  unshareTraffickingScreening (payload) {
    const request = fetch({
      url: `/unshare/traffickingscreening`,
      method: 'post',
      data: payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/sharing.js